export const ACTIVITY_STATEMENTS_ROUTE = 'account/activity-statements'
export const CREATE_ACTIVITY_STATEMENT_PATH = '/api/account/requestActivityStatement'
